var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer_box"},[_c('div',{staticClass:"container"},[_c('p',[_vm._v("地址: 杭州市拱墅区祥符街道中交财富大厦2号楼15楼1501 电话: 057185171361 E-mail: cacaca@zjsca.org.cn")]),_c('p',[_vm._v("备案号: 浙ICP备11032166号 "),_c('img',{attrs:{"src":require("../assets/images/img.png"),"alt":""}}),_vm._v(" 浙公网安备 33010302003296号")]),_c('p',[_vm._v("准到提供技术支持")])])])
}]

export { render, staticRenderFns }